import HeroSection from "./hero-section";
import Accordion from "../../components/accordion";
import ConsultationStaticForm from "../../components/consultation-static-form";
import CourseStats from "./course-stats";
import ReviewsSlider from "../../components/reviews-slider";
import OngoingWebinarMagnet from "./ongoing-webinar-magnet";
import ElementTransitions from "../../components/element-transitions";
import LeadMagnet from "./lead-magnet";
import MiniMagnet from "./mini-magnet";

export default class PageModule {
    constructor() {
        this.initOngoingWebinarMagnet();
        this.initHeroSection();
        this.initCourseStats();
        this.initProgrammeSection();
        this.initReviewsSection();
        this.initFAQSection();
        this.initConsultationStaticForm();
        this.initElementTransitions();
        this.initLeadMagnet();
        this.initMiniMagnet();
    }

    initOngoingWebinarMagnet() {
        new OngoingWebinarMagnet();
    }

    initHeroSection() {
        new HeroSection();
    }

    initCourseStats() {
        new CourseStats();
    }

    initProgrammeSection() {
        if (!document.getElementById('programmeExpandableList')) {
            return;
        }

        new Accordion('programmeExpandableList');
    }

    initReviewsSection() {
        new ReviewsSlider();
    }

    initFAQSection() {
        if (!document.getElementById('faqAccordion')) {
            return;
        }

        new Accordion('faqAccordion');
    }

    initConsultationStaticForm() {
        new ConsultationStaticForm();

    }

    initElementTransitions() {
        new ElementTransitions({
            $elems: Array.from(document.querySelectorAll(
                '.animate:not(.programme-goals):not(.programme-list-container)')),
        });
        new ElementTransitions({
            $elems: [
                document.querySelector('.programme-goals'),
                document.querySelector('.programme-list-container')
            ],
            threshold: 0.1
        });
    }

    initLeadMagnet() {
        new LeadMagnet();
    }

    initMiniMagnet() {
        new MiniMagnet();
    }
}